import { LocationStatus } from "@gtpl/shared-models/masters";
import { Locations } from "../location.entity";
import { LocationsDTO } from "./location-dto";
export class locationsAdapter {

    public convertDtoToEntity(details: LocationsDTO, rackCode:string,columnsCode:string,levelCode:string): Locations {
        console.log('ji');
        const locations = new Locations();
        if(details.locationId){
            locations.locationId = details.locationId;
            locations.updatedUser =details.updatedUser;
        }
        locations.locationName = rackCode+'-'+columnsCode+'-'+levelCode;
        locations.levelId = details.levelId;
        locations.rackId = details.rackId;
        locations.zoneId = details.zoneId;
        locations.columnId = details.columnId;
        locations.locationStatus = LocationStatus.Empty;
        locations.createdUser =details.createdUser;
        return locations;
    }
    
}